import styled from "styled-components";
export const Card = styled.div`
  /* width: 23%; */
  /* max-width: 222px; */
  width: 222px;
  scale: 0.8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 3rem;
  border-radius: 24px;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  position: relative;
  height: 280px;
  background-color: var(--white-bg);
  z-index: 20;
  margin: 0% 20px;

  p {
    text-align: center;
  }
  h3 {
    font-size: 1.6rem;
    font-weight: 70rem;
    color: var(--title-color);
    margin-top: 2.4rem;
  }
  &::after {
    content: "";
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-10px, -10px);
  }
  &::before {
    content: "";
    width: 100%;
    height: 280px;
    position: absolute;
    top: 0;
    right: 0;
    border: 2px dashed var(--border-dashed);
    border-radius: 24px;
    transform: rotate(-20deg);
    z-index: -5;
  }
`;

export const CardCounter = styled.div`
  border: 4px solid ${(props) => props.color};
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  right: -10%;
  z-index: 10;
  bottom: 50%;
  transform: translate(0, 50%);
  background-color: var(--white-bg);
  p {
    font-size: 6rem;
    font-weight: 50rem;
    color: ${(props) => props.color};
    font-family: Iran-Yekan;
  }
  @media (max-width: 450px) {
    scale: 0.8;
  }
`;
